export const privateGroupTooltip = "zLcxgc";
export const publicGroupTooltip = "NzHrlc";
export default {privateGroupTooltip,publicGroupTooltip};